export type NavLinkItem = {
  kind: 'link';
  labelKey: string;
  path?: string;
  disabled?: boolean;
};

export type NavMenuItem = {
  kind: 'menu';
  labelKey: string;
  items: NavSubItem[];
};

export type NavSubItem = {
  labelKey: string;
  path?: string;
  disabled?: boolean;
};

export type NavItem = NavLinkItem | NavMenuItem;

export const MAIN_NAV_ITEMS: NavItem[] = [
  {
    kind: 'menu',
    labelKey: 'nav.platforms',
    items: [
      { labelKey: 'nav.items.racialEquality', path: '/igualdade-racial' },
      { labelKey: 'nav.items.dataCuidados', path: '/datacuidados' },
      { labelKey: 'nav.items.regbr', path: '/regbr' },
      { labelKey: 'nav.items.evidenceExpress', path: '/evidencia-express' },
    ],
  },
  {
    kind: 'menu',
    labelKey: 'nav.resources',
    items: [
      { labelKey: 'nav.items.dataStories', path: '/datastories' },
      { labelKey: 'nav.items.questionCloud', path: '/nuvem-perguntas' },
      { labelKey: 'nav.items.reports', path: '/relatorios' },
    ],
  },
  { kind: 'link', labelKey: 'nav.events', path: '/eventos' },
  {
    kind: 'link',
    labelKey: 'nav.remoteResearchEnvironment',
    path: '/ambiente-remoto-pesquisa',
  },
  { kind: 'link', labelKey: 'nav.services', path: '/servicos' },
  { kind: 'link', labelKey: 'nav.aboutUs', path: '/quem-somos' },
];

export type FooterLink = {
  labelKey: string;
  path?: string;
  external?: boolean;
  disabled?: boolean;
};

export type FooterSection = {
  titleKey: string;
  ariaLabelKey: string;
  links: FooterLink[];
};

export const FOOTER_SECTIONS: FooterSection[] = [
  {
    titleKey: 'footer.platforms',
    ariaLabelKey: 'footer.platforms',
    links: [
      { labelKey: 'nav.items.racialEquality', path: '/igualdade-racial' },
      { labelKey: 'nav.items.dataCuidados', path: '/datacuidados' },
      { labelKey: 'nav.items.regbr', path: '/regbr' },
      { labelKey: 'nav.items.evidenceExpress', path: '/evidencia-express' },
    ],
  },
  {
    titleKey: 'footer.resources',
    ariaLabelKey: 'footer.resources',
    links: [
      { labelKey: 'nav.items.dataStories', path: '/datastories' },
      { labelKey: 'nav.items.questionCloud', path: '/nuvem-perguntas' },
      { labelKey: 'nav.items.reports', path: '/relatorios' },
      { labelKey: 'nav.services', path: '/servicos' },
      { labelKey: 'footer.arpShort', path: '/ambiente-remoto-pesquisa' },
      { labelKey: 'footer.dataDictionary', disabled: true },
    ],
  },
  {
    titleKey: 'footer.institution',
    ariaLabelKey: 'footer.institution',
    links: [
      { labelKey: 'footer.aboutUs', path: '/quem-somos' },
      { labelKey: 'footer.enap', path: 'https://www.enap.gov.br', external: true },
      {
        labelKey: 'footer.privacyPolicy',
        disabled: false,
        external: true,
        path: 'https://www.enap.gov.br/acesso-a-informacao/termo-de-uso-e-aviso-de-privacidade-enap/',
      },
    ],
  },
];
